import React, { useEffect, useState } from "react";
import {
    Card,
    Collapse,
    Typography,
    Input,
    Row,
    Col,
    Button,
    Space,
    message,
    Spin,
    Form,
} from "antd";
import {
    SendOutlined,
    CommentOutlined,
    DownOutlined,
    RightOutlined,
} from "@ant-design/icons";
import _AdministratorService from "../../../modules/AdministratorService";
import { COMMON_ERROR_MSG } from "../../../constants/constants";
import _commonService from "../../../modules/commonService";
import _consumerService from "../../../modules/consumerService";

const { Panel } = Collapse;
const { Text } = Typography;

const ReviewCommentByApplicationIdAndSection = ({ CommentSectionName }) => {
    const [allComments, setAllComments] = useState([]);
    const [loading, setLoading] = useState(false);
    // const ApplicationObjId = parseInt(localStorage.getItem("ApplicationObjId"));
    const ApplicationObjId = parseInt(localStorage.getItem("ConsumerUserId"));
    const ApplicationStatusId = JSON.parse(localStorage.getItem("ApplicationStatusId"));
    const ApplicantName = localStorage.getItem("ApplicantName");
    const [form] = Form.useForm();
    useEffect(() => {
        getApplicationReviewComment();
    }, []);

    const getApplicationReviewComment = async () => {
        try {
            setLoading(true);
            const res = await _consumerService.getApplicationReviewCommentByApplicationIdAndSection(ApplicationObjId, CommentSectionName);

            if (res.data.IsSuccess) {
                const filteredRemarks = res.data.Obj?.filter((item) =>
                    (item.ReviewCommentsBy_BankerId && item.ReviewCommentsBy_BankerId > 0) ||
                    (item.IsCommentByApplicant === true)
                );
                setAllComments(filteredRemarks || []);
            } else {
                message.error(res.data.Message || COMMON_ERROR_MSG);
            }
        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false);
        }
    };
    const handleAddComment = async (values) => {
        const { comment } = values;

        const reqObj = {
            Section: CommentSectionName,
            ApplicationId: ApplicationObjId,
            // Remarks: remarks.trim(),
            Comments: comment.trim(),
            ReviewCommentsBy_BankerId: null,
            ReviewCommentsBy_LoanOfficerId: null,
            ApplicationStatusId: ApplicationStatusId,
        };

        try {
            setLoading(true);
            const res = await _AdministratorService.addApplicationReviewComment(reqObj);
            if (res.data.IsSuccess) {
                message.success(res.data.Message);
                getApplicationReviewComment();
                form.resetFields();
            } else {
                message.error(res.data.Message || COMMON_ERROR_MSG);
            }
        } catch (err) {
            console.error(err);
            message.error(COMMON_ERROR_MSG);
        } finally {
            setLoading(false);
        }
    };
    return (
        <Spin spinning={loading}>
            {/* {comments.length > 0 && ( */}
            <Card
                className="commentSectionCard"
                title={
                    <Space>
                        <CommentOutlined />
                        <Text strong>Comments</Text>
                    </Space>
                }
                style={{ borderRadius: 12 }}
            >
                <Collapse
                    accordion
                    collapsible="icon"
                    expandIcon={({ isActive }) =>
                        isActive ? <DownOutlined /> : <RightOutlined />
                    }
                    bordered={false}
                >
                    {allComments
                        ?.filter(
                            (comment) =>
                                comment.Section === CommentSectionName &&
                                (comment.ReviewCommentsBy_BankerId > 0 || comment.IsCommentByApplicant)
                        )
                        .map((comment) => (
                            <Panel
                                key={comment.Id}
                                header={
                                    <Row justify="space-between" style={{ width: "100%" }}>
                                        <Col>
                                            <Text strong>
                                                {comment.IsCommentByApplicant
                                                    ? "App"
                                                    : comment.ReviewCommentsBy_BankerId > 0
                                                        ? "B.O"
                                                        : "L.O"}{" "}
                                                |

                                                {" "}
                                                {comment.IsCommentByApplicant
                                                    ? ApplicantName
                                                    : comment.ReviewCommentsBy_BankerId > 0
                                                        ? comment.ReviewCommentsBankerName
                                                        : comment.ReviewCommentsLoanOfficerName}
                                            </Text>
                                        </Col>
                                        <Col>
                                            <Text type="secondary" style={{ fontSize: 12 }}>
                                                {comment.CreatedDate
                                                    ? _commonService.formatDateTimeAMPM(comment.CreatedDate)
                                                    : "N/A"}
                                            </Text>
                                        </Col>
                                    </Row>
                                }
                            >
                                {/* <div>
                                    <Text><b>Remarks:</b> {comment.Remarks}</Text>
                                </div> */}
                                <div>
                                    <Text><b>Comment:</b> {comment.Comments}</Text>
                                </div>
                            </Panel>
                        ))}
                </Collapse>

                {/* Comment Input Form */}
                {ApplicationStatusId === 5 && (
                    <Form
                        form={form}
                        layout="vertical"
                        onFinish={handleAddComment}
                        initialValues={{ comment: "", remarks: "" }}
                    >
                        <Row gutter={16} style={{ marginTop: 16, borderTop: "1px solid #eee", paddingTop: 12 }}>

                            <Col span={22}>
                                <Form.Item
                                    name="comment"
                                    rules={[{ required: true, message: "Comment is required" }]}
                                >
                                    <Input.TextArea
                                        placeholder="comments *"
                                        autoSize={{ minRows: 2, maxRows: 6 }}
                                    />
                                </Form.Item>
                            </Col>
                            <Col span={2} style={{ display: "flex", alignItems: "end" }}>
                                <Form.Item>
                                    <Button
                                        type="primary"
                                        htmlType="submit"
                                    >
                                        <SendOutlined />
                                    </Button>
                                </Form.Item>
                            </Col>
                        </Row>
                    </Form>
                )}

            </Card>
            {/* )} */}
        </Spin>
    );
};

export default ReviewCommentByApplicationIdAndSection;